<template>
  <div>
    <div class="content">
      <!--      <div class="content-main">-->
      <!--        <p class="content-title">用户权限</p>-->
      <!--      </div>-->
      <div class="content-main">
        <p class="content-title" style="padding-bottom: 16px;">微信支付配置</p>
        <div class="content-table">
          <el-table
              ref="multipleTableRef"
              :data="pageDataList"
              style="width: 100%; padding-bottom: 12px;"
              v-loading="loading"
              size="default"
          >
            <!--            <el-table-column property="id" label="ID" v-if="checkColList.indexOf('ID') > -1"/>-->
            <el-table-column property="mchId" label="商户号"/>
            <el-table-column property="packageName" label="包名"/>
            <el-table-column property="appId" label="应用id"/>
<!--            <el-table-column property="remark" label="备注"/>-->
            <el-table-column property="" label="状态">
              <template #default="scope">
                {{scope.row.state == 1?'开启':scope.row.state == 2?'关闭':''}}
<!--                <p>收款账号：<span :style="{color: scope.row.state == 1?'#409eff':''}">{{scope.row.state == 1?'是':'否'}}</span></p>-->
<!--                <p>打款账号：<span :style="{color: scope.row.payState == 1?'#409eff':''}">{{scope.row.payState == 1?'是':'否'}}</span></p>-->
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template #default="scope">
                <el-button type="primary" v-if="scope.row.state==2 || scope.row.state==0" @click="updatePay(scope.row, 1)" size="small">开启</el-button>
                <el-button type="danger" v-if="scope.row.state==1" @click="updatePay(scope.row, 2)" size="small">关闭</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { getFormData, postFormData } from "@/api/api";
import { getWxPayPageList, updateWxPayState } from "@/api/url";

export default {
  name: "Alipay",
  data() {
    return {
      pageDataList: [],
      loading: false,
    }
  },
  methods: {

    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },

    getPage() {
      this.loading = true
      let param = {};
      getFormData(getWxPayPageList, param).then((data)=>{
        let {msg, code} = data
        if (code == 200) {
          this.pageDataList = data.data.records
        }else {
          this.$message({
            message: msg,
            type: 'warning',
            duration: 1000,
          })
        }
        this.loading = false
      }).catch((err) => {
        this.loading = false
        this.$message({
          message: err.msg,
          type: 'warning',
          duration: 1000
        })
      })
    },

    updatePay(row, state) {
      this.$confirm('确定' + state == 1?'开启？':'关闭？').then(() => {
        postFormData(updateWxPayState, { id: row.id, state: state }).then((data) => {
          let { code, msg } = data;
          if(code == 200) {
            this.$message({
              showClose: true,
              duration: 1000,
              message:msg,
              type: 'success'
            });
            this.getPage()
          }else {
            this.$message({
              showClose: true,
              duration: 1000,
              message:msg,
              type: 'error'
            });
          }
          this.loading = false;
        })
      }).catch(()=> {});
    }


  },
  mounted() {
    this.getPage();
  }
}
</script>

<style scoped>
.el-table {
  --el-table-header-bg-color: #ffffff !important;
}
</style>
